import { Button, Icon } from '@data-products-and-ai/react-components';
import { useNavigate, generatePath } from 'react-router';
import { FC } from 'react';
import classnames from 'classnames';

interface BackButtonProps {
  className?: string;
  label?: string;
  url: string;
}

export const BackButton: FC<BackButtonProps> = ({ url, label, className }) => {
  const navigate = useNavigate();
  const classNames = classnames('back-button', className);

  const handleClick = () => {
    navigate(generatePath(url));
  };

  return (
    <div className={classNames}>
      <Button
        type="primaryNoShadow"
        size="small"
        allCaps={false}
        icon={
          <Icon
            icon="IconArrowLeft"
            iconSize={0.75}
            color="var(--color-white)"
          />
        }
        onClick={handleClick}
      >
        {label || 'Back'}
      </Button>
    </div>
  );
};
